import AdminVendorCreatePage from '@/features/vendors/routes/AdminVendorCreatePage'
import AdminVendorDetailPage from '@/features/vendors/routes/AdminVendorDetailPage'
import React from 'react'
import AdminVendors from './AdminVendorListPage'
import TemporaryVendors from './TemporaryVendorListPage'

export const vendorAdminRoutes = [
  {
    breadcrumb: 'Vendors',
    path: '',
    element: <AdminVendors />,
    children: [],
  },
  {
    breadcrumb: 'Temporary Vendors',
    path: 'temporary',
    element: <TemporaryVendors />,
    children: [],
  },
  {
    breadcrumb: 'Vendors Create',
    path: 'create',
    element: <AdminVendorCreatePage />,
    children: [],
  },
  {
    breadcrumb: 'Vendors Details',
    path: ':id',
    element: <AdminVendorDetailPage />,
    children: [],
  },
]

export default vendorAdminRoutes
